<stzh-cspace>
  <stzh-heading level="1" id="anchorContent">Angebotseingabe für Ausschreibungen der Stadt Zürich</stzh-heading>

  <div class="mod_styledtext">

    <p>Willkommen im Angebotseingabe-Tool für Ausschreibungen der Stadt Zürich. Hier finden Sie alle Ihre offenen
    Angebotseingaben zu Ausschreibungen bei der Stadt Zürich.</p>
    <p>Neue öffentliche Ausschreibungen finden Sie jeweils auf <a class="icon extern"
      href="https://www.simap.ch"
    target="_blank">Simap</a></p>
    <p>Bis zur Eingabefrist der Ausschreibung und solange das Angebot noch nicht versendet wurde, können Sie sich
      jederzeit
    wieder einloggen und Ergänzungen oder Korrekturen zu Ihrem Angebot vornehmen.</p>
    <p></p></div>
  <div class="mod_table">
    <stzh-cspace>
      <stzh-heading level="2">Meine Ausschreibungen</stzh-heading>
      <div>
      <div class="table responsive-table">
        @if (((ausschreibungen$ | async)?.length ?? 0) > 0 ) {
          <table>
            <thead>
              <tr>
                <th scope="col"><b>Objekt</b></th>
                <th scope="col"><b>Beschreibung</b></th>
                <th scope="col"><b>Einreichungsfrist</b></th>
                <th scope="col"><b>Status</b></th>
                <th scope="col"><b>Übermittlungsdatum</b></th>
                <th scope="col"><span class="visuallyhidden">Beiblatt</span></th>
                <th scope="col"><span class="visuallyhidden">Entfernen</span></th>
              </tr>
            </thead>
            <tbody>
              @for (ausschreibung of (ausschreibungen$ | async); track ausschreibung) {
                <tr class="point">
                  <td (click)="open(ausschreibung.id)"><a>{{ausschreibung.objekt}}</a></td>
                  <td (click)="open(ausschreibung.id)">{{ausschreibung.bezeichnung}}</td>
                  @if (!isFreihaendig(ausschreibung?.verfahrensartSTADTZH)) {
                    @if (ausschreibung.einreichefrist) {
                      <td (click)="open(ausschreibung.id)"
                        >{{ausschreibung.einreichefrist | date : 'dd.MM.yyyy, H:mm'}}
                        Uhr
                      </td>
                    } @else {
                      <td></td>
                    }
                  } @else {
                    <td (click)="open(ausschreibung.id)">-</td>
                  }
                  <td (click)="open(ausschreibung.id)">{{beautifyState(ausschreibung.status,
                  ausschreibung.einreichefrist)}}</td>
                  @if (ausschreibung.uebermittlungsdatum) {
                    <td (click)="open(ausschreibung.id)"
                      >{{ausschreibung.uebermittlungsdatum | date : 'dd.MM.yyyy, H:mm'}}
                      Uhr
                    </td>
                  } @else {
                    <td></td>
                  }
                  <td>@if (ausschreibung.beiblatt === true && ausschreibung.status === 'BEENDET') {
                    <a
                      (click)="downloadBeiblatt(ausschreibung.id)"
                      title="Bestätigung drucken"
                    class="icon_ico_printer"></a>
                  }</td>
                  @if (!isFreihaendig(ausschreibung?.verfahrensartSTADTZH)) {
                    @if (!greyIcon(ausschreibung.status, ausschreibung.einreichefrist)) {
                      <td>
                        <a (click)="removeAusschreibung(ausschreibung.id)"
                          title="Angebot löschen"
                        class="icon_ico_trash2"></a></td>
                      }
                      @if (greyIcon(ausschreibung.status, ausschreibung.einreichefrist)) {
                        <td><a (click)="showHint()"
                          title="Angebot löschen"
                        class="icon_ico_trash2 icon-grey"></a>
                      </td>
                    }
                  } @else {
                    <td></td>
                  }
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p>Keine Ausschreibungen vorhanden.</p>
        }
      </div>
    </div>
    </stzh-cspace>
  </div>
</stzh-cspace>
